export default __webpack_public_path__ + "static/media/library.19390d97.jpg";